@if (isPowerSignal()) {
  @let pSignal = powerSignal();
  <notifications-notification-item
    [message]="message()"
    [subjectTemplate]="powerSubjectTemplate"
    [bodyTemplate]="powerBodyTemplate"
  ></notifications-notification-item>

  <ng-template #powerSubjectTemplate let-message>
    {{
      'limit-reports.notification.limitreportpowersignal.TITLE'
        | transloco: { name: pSignal.limitReport?.caption }
    }}
  </ng-template>

  <ng-template #powerBodyTemplate let-message>
    <div class="flex flex-row items-center w-full">
      <div class="icon spacer">
        <fa-icon [icon]="faPlug" class="power-icon"></fa-icon>
      </div>
      <div class="flex flex-col w-full overflow-hidden">
        <div class="truncate">
          <span class="italic"
            >{{
              'limit-reports.notification.limitreportbuysignal.CUSTOMER'
                | transloco
            }}:
          </span>
          <span>{{ pSignal.customer?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic"
            >{{
              'limit-reports.notification.limitreportbuysignal.LIMITREPORT'
                | transloco
            }}:
          </span>
          <span>{{ pSignal.limitReport?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.PRODUCT'
                | transloco
            }}:
          </span>
          <span>{{ pSignal.product?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.SIGNALDATE'
                | transloco
            }}:
          </span>
          <span>{{ pSignal.signalDate | date: 'mediumDate' }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.STRATEGY'
                | transloco
            }}:
          </span>
          <span>{{ powerStrategyKey() | transloco }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportpowersignal.PRICE'
                | transloco
            }}:
          </span>
          <span
            >{{ pSignal.signalDatePrice | number: '1.2-2' }}
            {{ pSignal.unit }}</span
          >
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportpowersignal.LIMIT'
                | transloco
            }}:
          </span>
          <span
            >{{ pSignal.limitPrice | number: '1.2-2' }}
            {{ pSignal.unit }}</span
          >
        </div>
      </div>
    </div>
  </ng-template>
} @else if (isGasSignal()) {
  @let gSignal = gasSignal();
  <notifications-notification-item
    [message]="message()"
    [subjectTemplate]="gasSubjectTemplate"
    [bodyTemplate]="gasBodyTemplate"
  ></notifications-notification-item>

  <ng-template #gasSubjectTemplate let-message>
    {{
      'limit-reports.notification.limitreportgassignal.TITLE'
        | transloco: { name: gSignal.limitReport?.caption }
    }}
  </ng-template>

  <ng-template #gasBodyTemplate let-message>
    <div class="flex flex-row items-center w-full">
      <div class="icon spacer">
        <fa-icon [icon]="faBurn" class="gas-icon"></fa-icon>
      </div>
      <div class="flex flex-col w-full overflow-hidden">
        <div class="truncate">
          <span class="italic"
            >{{
              'limit-reports.notification.limitreportbuysignal.CUSTOMER'
                | transloco
            }}:
          </span>
          <span>{{ gSignal.customer?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic"
            >{{
              'limit-reports.notification.limitreportbuysignal.LIMITREPORT'
                | transloco
            }}:
          </span>
          <span>{{ gSignal.limitReport?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.PRODUCT'
                | transloco
            }}:
          </span>
          <span>{{ gSignal.product?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.SIGNALDATE'
                | transloco
            }}:
          </span>
          <span>{{ gSignal.signalDate | date: 'mediumDate' }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.STRATEGY'
                | transloco
            }}:
          </span>
          <span>{{ gasStrategyKey() | transloco }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportgassignal.PRICE'
                | transloco
            }}:
          </span>
          <span
            >{{ gSignal.signalDatePrice | number: '1.2-2' }}
            {{ gSignal.unit }}</span
          >
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportgassignal.LIMIT'
                | transloco
            }}:
          </span>
          <span
            >{{ gSignal.limitPrice | number: '1.2-2' }}
            {{ gSignal.unit }}</span
          >
        </div>
      </div>
    </div>
  </ng-template>
} @else if (isOtherSignal()) {
  @let oSignal = otherSignal();
  <notifications-notification-item
    [message]="message()"
    [subjectTemplate]="otherSubjectTemplate"
    [bodyTemplate]="otherBodyTemplate"
  ></notifications-notification-item>

  <ng-template #otherSubjectTemplate let-message>
    {{
      'limit-reports.notification.limitreportothersignal.TITLE'
        | transloco: { name: oSignal.limitReport?.caption }
    }}
  </ng-template>

  <ng-template #otherBodyTemplate let-message>
    <div class="flex flex-row items-center w-full">
      <div class="icon spacer">
        <fa-icon [icon]="faBorderAll" class="other-icon"></fa-icon>
      </div>
      <div class="flex flex-col w-full overflow-hidden">
        <div class="truncate">
          <span class="italic"
            >{{
              'limit-reports.notification.limitreportbuysignal.CUSTOMER'
                | transloco
            }}:
          </span>
          <span>{{ oSignal.customer?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic"
            >{{
              'limit-reports.notification.limitreportbuysignal.LIMITREPORT'
                | transloco
            }}:
          </span>
          <span>{{ oSignal.limitReport?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.PRODUCT'
                | transloco
            }}:
          </span>
          <span>{{ oSignal.product?.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.SIGNALDATE'
                | transloco
            }}:
          </span>
          <span>{{ oSignal.signalDate | date: 'mediumDate' }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.STRATEGY'
                | transloco
            }}:
          </span>
          <span>{{ otherStrategyKey() | transloco }}</span>
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportothersignal.PRICE'
                | transloco
            }}:
          </span>
          <span
            >{{ oSignal.signalDatePrice | number: '1.2-2' }}
            {{ oSignal.unit }}</span
          >
        </div>
        <div class="truncate">
          <span class="italic">
            {{
              'limit-reports.notification.limitreportothersignal.LIMIT'
                | transloco
            }}:
          </span>
          <span
            >{{ oSignal.limitPrice | number: '1.2-2' }}
            {{ oSignal.unit }}</span
          >
        </div>
      </div>
    </div>
  </ng-template>
} @else {
  @let bSignal = buySignal();
  <notifications-notification-item
    [message]="message()"
    [subjectTemplate]="subjectTemplate"
    [bodyTemplate]="bodyTemplate"
  ></notifications-notification-item>

  <ng-template #subjectTemplate let-message>
    {{ 'limit-reports.notification.limitreportbuysignal.BUYSIGNAL' | transloco }}
  </ng-template>

  <ng-template #bodyTemplate let-message>
    <div class="flex flex-row items-center w-full">
      <div class="icon spacer" matTooltip="{{ bSignal.energySource }}">
        @switch (bSignal.energySource) {
          @case ('Gas') {
            <fa-icon [icon]="faBurn" class="gas-icon"></fa-icon>
          }
          @case ('Power') {
            <fa-icon [icon]="faPlug" class="power-icon"></fa-icon>
          }
          @case ('Other') {
            <fa-icon [icon]="faBorderAll" class="other-icon"></fa-icon>
          }
          @default {
            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          }
        }
      </div>
      <div class="flex flex-col w-full overflow-hidden">
        <div class="truncate">
          <span class="italic"
            >{{
              'limit-reports.notification.limitreportbuysignal.CUSTOMER'
                | transloco
            }}:
          </span>
          <span>{{ bSignal.customer.caption }}</span>
        </div>
        <div class="truncate">
          <span class="italic"
            >{{
              'limit-reports.notification.limitreportbuysignal.LIMITREPORT'
                | transloco
            }}:
          </span>
          <span>
            {{ bSignal.limitReport.caption }}
          </span>
        </div>
        <div>
          <span class="italic">
            {{
              'limit-reports.notification.limitreportbuysignal.PRODUCT'
                | transloco
            }}: </span
          ><span>{{ bSignal.product.caption }}</span>
        </div>
        <div class="flex flex-row">
          <div class="flex-grow">
            <span class="italic">
              {{
                'limit-reports.notification.limitreportbuysignal.STRATEGY'
                  | transloco
              }}:
            </span>
            <span>{{ bSignal.strategy }}</span>
          </div>
          <div>
            <span class="italic">
              {{
                'limit-reports.notification.limitreportbuysignal.SIGNALDATE'
                  | transloco
              }}:
            </span>
            <span>{{ bSignal.signalDate | date: 'mediumDate' }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
}
